function stripEnvQuotes(value) {
  if (value == null || value === '') return '';
  return String(value).replace(/^['"]|['"]$/g, '').trim();
}

/**
 * Env feature toggles: `yes` = show, `no` = hide (case-insensitive).
 */
export function isEnvFeatureShown(envValue) {
  const normalized = stripEnvQuotes(envValue).toLowerCase();
  return normalized === 'yes';
}

/** Feed, paid course pricing, and related modules — REACT_APP_FEATURE_FEED */
export function isFeedFeatureEnabled() {
  return isEnvFeatureShown(process.env.REACT_APP_FEATURE_FEED);
}

export function isAdminCourseYoutubeEnabled() {
  return isEnvFeatureShown(process.env.REACT_APP_FEATURE_ADMIN_COURSE_YOUTUBE);
}

/** Plivo SMS toggle — REACT_APP_PLIVO_ENABLED (`yes`/`no` or `true`/`false`) */
export function isPlivoEnabled() {
  const normalized = stripEnvQuotes(process.env.REACT_APP_PLIVO_ENABLED).toLowerCase();
  return normalized === 'yes' || normalized === 'true';
}
